import {Component, Inject, ViewChild} from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import {IdexService} from 'app/idex.service';
import {LoadingButtonComponent} from 'app/shared/loading-button/button';
import {Toast} from 'app/shared/toast/toast';

@Component({
   selector: 'app-resend-verify-email',
   templateUrl: 'resend-verify-email.component.html',
   styleUrls: ['resend-verify-email.component.css']
})
export class ResendVerifyEmailComponent {
   errorMessage: string;
   email: any;
   @ViewChild('submitResend') button: LoadingButtonComponent;

   constructor(private dialogRef: MatDialogRef<ResendVerifyEmailComponent>, @Inject(MAT_DIALOG_DATA) private data: any,
               private service: IdexService, public toast: Toast) {
   }

   resendEmail(input: any) {
      this.service.resendEmail(input.value)
         .subscribe(data => {
               this.dialogRef.close();
               this.toast.info(data);
            },
            error => {
               this.button.reset();
               input.focus();
               this.errorMessage = error;
            }
         );
   }

   /**
    *
    * @details : check pattern input email
    */
   checkEmail(input: any, button: any) {
      const reg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
      button.disabled = !reg.test(input.value);
   }
}
